export default "__VITE_ASSET__CFA7QfiA__"